import socialMediaConfig from '@/assets/common/social-media-config';

export default [
    //Twitter

    {
        author_followers_count: 5433,
        username: 'JamesBaison',
        photo_url: '',
        favoritedBy: ['1', '2'], //@TODO - only for testing
        retweetedBy: ['3'], //@TODO - only for testing
        language: 'en',
        description: 'James Baison',
        created_at: '2021-08-08T11:27:03.000Z', // !: NOTE: @TODO | in old affogata, created_at is inside status object
        related_profiles: ['2', '1'],
        author_id: 1,
        is_replied: 0,
        state: 1,
        sentiment: 1,
        social_type: socialMediaConfig.twitter.id,
        post_url: 'https://twitter.com/?lang=en',
        status: {
            created_at: '2022-03-24T09:24:00.000Z',
            subreddit_name: 'JamesReddit',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '1m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 12,
            user_mentions: [
                {
                    screen_name: 'James Baison',
                    name: 'James Baison',
                    id: '1',
                    id_str: '1',
                    indices: [0, 12]
                }
            ],
            in_reply_to_screen_name: 'Queen',
            reply_count: 1,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399000,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        author_followers_count: 112,
        username: 'OzzyOsbourne',
        photo_url: '',
        description: 'Ozzy Osbourne',
        created_at: '2022-01-01T11:27:03.000Z',
        related_profiles: ['2'],
        favoritedBy: ['3'], //@TODO - only for testing
        retweetedBy: ['2'], //@TODO - only for testing
        author_id: 2,
        state: 1,
        is_replied: 1,
        sentiment: -1,
        post_url: 'https://twitter.com/?lang=en',
        language: 'la',
        social_type: socialMediaConfig.twitter.id,
        status: {
            created_at: '2022-03-24T10:24:00.000Z',
            subreddit_name: 'OzzyRedditOsbourne',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '2m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 0,
            reply_count: 89,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399001,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        author_followers_count: 1,
        username: 'DavidGuetta',
        photo_url: '',
        retweetedBy: ['2'], //@TODO - only for testing
        post_url: 'https://twitter.com/?lang=en',
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08T11:27:03.000Z',
        related_profiles: ['2', '1'],
        state: 3,
        author_id: 3,
        is_replied: 0,
        social_type: socialMediaConfig.twitter.id,
        sentiment: 0,
        status: {
            created_at: '2022-03-19T08:24:00.000Z',
            subreddit_name: 'Guetta123',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '3m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 9,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'la',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    in_reply_to_status_id: '',
                    in_reply_to_user_id: '',
                    in_reply_to_screen_name: '',
                    in_reply_to_media_id: '',
                    parent_created_at_timestamp: null,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    urls: [],
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            display_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            media_url_https:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                small: {
                                    w: 150,
                                    h: 150
                                },
                                thumb: {
                                    w: 90,
                                    h: 90
                                },
                                medium: {
                                    w: 300,
                                    h: 300
                                },
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    author_followers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    fb_user_type: 2,
                    social_type: socialMediaConfig.facebook.id
                }
            }
        }
    },

    //Instagram

    {
        author_followers_count: 5433,
        username: 'JamesBaison',
        photo_url: '',
        language: 'en',
        description: 'James Baison',
        created_at: '2021-08-08T11:27:03.000Z',
        related_profiles: ['2', '1'],
        author_id: 1,
        is_replied: 0,
        post_url: 'https://www.instagram.com/',
        state: 1,
        sentiment: 1,
        social_type: socialMediaConfig.instagram.id,
        status: {
            created_at: '2022-03-17T08:24:00.000Z',
            subreddit_name: 'JamesReddit',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '1m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQabc',
            favorite_count: 12,
            user_mentions: [
                {
                    screen_name: 'James Baison',
                    name: 'James Baison',
                    id: '1',
                    id_str: '1',
                    indices: [0, 12]
                }
            ],
            in_reply_to_screen_name: 'Queen',
            reply_count: 1,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399000,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },

    {
        author_followers_count: 112,
        username: 'OzzyOsbourne',
        photo_url: '',
        description: 'Ozzy Osbourne',
        created_at: '2022-01-01T11:27:03.000Z',
        post_url: 'https://www.instagram.com/',
        related_profiles: ['2'],
        author_id: 2,
        state: 1,
        is_replied: 1,
        sentiment: -1,
        language: 'la',
        social_type: socialMediaConfig.instagram.id,
        status: {
            created_at: '2022-03-15T08:24:00.000Z',
            subreddit_name: 'OzzyRedditOsbourne',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '2m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQabc',
            favorite_count: 0,
            reply_count: 89,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399001,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },

    {
        author_followers_count: 1,
        username: 'DavidGuetta',
        photo_url: '',
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08T11:27:03.000Z',
        post_url: 'https://www.instagram.com/',
        related_profiles: ['2', '1'],
        state: 3,
        author_id: 3,
        is_replied: 0,
        social_type: socialMediaConfig.instagram.id,
        sentiment: 0,
        status: {
            created_at: '2022-03-16T09:24:00.000Z',
            subreddit_name: 'Guetta123',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '3m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQabc',
            favorite_count: 9,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    in_reply_to_status_id: '',
                    in_reply_to_user_id: '',
                    in_reply_to_screen_name: '',
                    in_reply_to_media_id: '',
                    parent_created_at_timestamp: null,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    urls: [],
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            display_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            media_url_https:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                small: {
                                    w: 150,
                                    h: 150
                                },
                                thumb: {
                                    w: 90,
                                    h: 90
                                },
                                medium: {
                                    w: 300,
                                    h: 300
                                },
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    author_followers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    fb_user_type: 2,
                    social_type: socialMediaConfig.facebook.id
                }
            }
        }
    },

    //Facebook

    {
        author_followers_count: 5433,
        fb_user_type: 2,
        favoritedBy: ['1', '2'], //@TODO - only for testing
        username: 'JamesBaison',
        photo_url: '',
        language: 'en',
        description: 'James Baison',
        post_url: 'https://www.facebook.com/',
        created_at: '2021-08-08T11:27:03.000Z',
        related_profiles: ['2', '1'],
        author_id: 1,
        is_replied: 0,
        state: 1,
        sentiment: 1,
        social_type: socialMediaConfig.facebook.id,
        status: {
            created_at: '2022-03-20T05:24:00.000Z',
            subreddit_name: 'JamesReddit',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '1m_44m54354XIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 12,
            user_mentions: [
                {
                    screen_name: 'James Baison',
                    name: 'James Baison',
                    id: '1',
                    id_str: '1',
                    indices: [0, 12]
                }
            ],
            in_reply_to_screen_name: 'Queen',
            reply_count: 1,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399000,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        author_followers_count: 112,
        fb_user_type: 1,
        username: 'OzzyOsbourne',
        favoritedBy: ['3'], //@TODO - only for testing
        photo_url: '',
        description: 'Ozzy Osbourne',
        post_url: 'https://www.facebook.com/',
        created_at: '2022-01-01T11:27:03.000Z',
        related_profiles: ['2'],
        author_id: 2,
        state: 1,
        is_replied: 1,
        sentiment: -1,
        language: 'la',
        social_type: socialMediaConfig.facebook.id,
        status: {
            created_at: '2022-03-23T09:24:00.000Z',
            subreddit_name: 'OzzyRedditOsbourne',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id:
                '2m_44mXIO2cat54354453Qb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 0,
            reply_count: 89,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399001,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        author_followers_count: 1,
        fb_user_type: 5,
        username: 'DavidGuetta',
        favoritedBy: [], //@TODO - only for testing
        photo_url: '',
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08T11:27:03.000Z',
        post_url: 'https://www.facebook.com/',
        related_profiles: ['2', '1'],
        state: 3,
        author_id: 3,
        is_replied: 0,
        social_type: socialMediaConfig.facebook.id,
        sentiment: 0,
        status: {
            created_at: '2022-03-24T09:24:00.000Z',
            subreddit_name: 'Guetta123',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '3m_44mXIO2cat54345Qb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 9,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.instagram.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    in_reply_to_status_id: '',
                    in_reply_to_user_id: '',
                    in_reply_to_screen_name: '',
                    in_reply_to_media_id: '',
                    parent_created_at_timestamp: null,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    urls: [],
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            display_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            media_url_https:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                small: {
                                    w: 150,
                                    h: 150
                                },
                                thumb: {
                                    w: 90,
                                    h: 90
                                },
                                medium: {
                                    w: 300,
                                    h: 300
                                },
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    author_followers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    fb_user_type: 2,
                    social_type: socialMediaConfig.instagram.id
                }
            }
        }
    },

    // Reddit

    {
        author_followers_count: 5433,
        username: 'JamesBaison',
        photo_url: '',
        language: 'en',
        post_url: 'https://www.reddit.com/',
        description: 'James Baison',
        created_at: '2021-08-08T11:27:03.000Z',
        related_profiles: ['2', '1'],
        author_id: 1,
        is_replied: 0,
        state: 1,
        sentiment: 1,
        social_type: socialMediaConfig.reddit.id,
        status: {
            created_at: '2022-03-24T05:24:00.000Z',
            subreddit_name: 'JamesReddit',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '4m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 12,
            user_mentions: [
                {
                    screen_name: 'James Baison',
                    name: 'James Baison',
                    id: '1',
                    id_str: '1',
                    indices: [0, 12]
                }
            ],
            in_reply_to_screen_name: 'Queen',
            reply_count: 1,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399000,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        author_followers_count: 112,
        username: 'OzzyOsbourne',
        photo_url: '',
        description: 'Ozzy Osbourne',
        post_url: 'https://www.reddit.com/',
        created_at: '2022-01-01T11:27:03.000Z',
        related_profiles: ['2'],
        author_id: 2,
        state: 1,
        is_replied: 1,
        sentiment: -1,
        language: 'la',
        social_type: socialMediaConfig.reddit.id,
        status: {
            created_at: '2022-03-24T06:24:00.000Z',
            subreddit_name: 'OzzyRedditOsbourne',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '5m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 0,
            reply_count: 89,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399001,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        author_followers_count: 1,
        username: 'DavidGuetta',
        photo_url: '',
        language: 'en',
        description: 'David Guetta',
        post_url: 'https://www.reddit.com/',
        created_at: '2019-08-08T11:27:03.000Z',
        related_profiles: ['2', '1'],
        state: 3,
        author_id: 3,
        is_replied: 0,
        social_type: socialMediaConfig.reddit.id,
        sentiment: 0,
        status: {
            created_at: '2022-03-24T10:34:00.000Z',
            subreddit_name: 'Guetta123',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '6m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            favorite_count: 9,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '7105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    in_reply_to_status_id: '',
                    in_reply_to_user_id: '',
                    in_reply_to_screen_name: '',
                    in_reply_to_media_id: '',
                    parent_created_at_timestamp: null,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    urls: [],
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            display_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            media_url_https:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                small: {
                                    w: 150,
                                    h: 150
                                },
                                thumb: {
                                    w: 90,
                                    h: 90
                                },
                                medium: {
                                    w: 300,
                                    h: 300
                                },
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    author_followers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    fb_user_type: 2,
                    social_type: socialMediaConfig.facebook.id
                }
            }
        }
    },

    // Youtube

    {
        social_type: socialMediaConfig.youtube.id,
        username: 'DavidGuetta',
        photo_url: '',
        post_url: 'https://www.youtube.com/',
        related_profiles: ['2', '1'],
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08T11:27:03.000Z',
        state: 3,
        is_replied: 0,
        sentiment: 0,
        status: {
            created_at: '2022-03-24T08:24:00.000Z',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '8m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            subscribers_count: 343,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            media: [
                {
                    id: null,
                    id_str: '',
                    indices: null,
                    url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    expanded_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                    type: 'photo',
                    sizes: {
                        large: {
                            w: 452,
                            h: 418
                        }
                    }
                }
            ],
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '9105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    subscribers_count: 635634,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    subscribers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    social_type: socialMediaConfig.youtube.id
                }
            }
        }
    },

    {
        social_type: socialMediaConfig.youtube.id,
        username: 'DavidGuetta',
        photo_url: '',
        post_url: 'https://www.youtube.com/',
        related_profiles: ['2', '1'],
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08T13:27:03.000Z',
        state: 3,
        is_replied: 0,
        sentiment: 1,
        status: {
            created_at: '2022-03-24T08:24:00.000Z',
            full_text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '8m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQabc',
            subscribers_count: 343,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            media: [],
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '9105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    subscribers_count: 635634,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    subscribers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    social_type: socialMediaConfig.youtube.id
                }
            }
        }
    },

    {
        social_type: socialMediaConfig.youtube.id,
        username: 'DavidGuetta',
        photo_url: '',
        post_url: 'https://www.youtube.com/',
        related_profiles: ['2', '1'],
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08915:27:03.000Z',
        state: 3,
        is_replied: 0,
        sentiment: -1,
        status: {
            created_at: '2022-03-24T08:24:00.000Z',
            full_text: 'I do not recommend this channel',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '8m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQdef',
            subscribers_count: 343,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            media: [],
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '9105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    subscribers_count: 635634,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    subscribers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    social_type: socialMediaConfig.youtube.id
                }
            }
        }
    },

    // Linkedin

    {
        description: 'Head of Marketing at Affogata',
        social_type: socialMediaConfig.linkedin.id,
        username: 'David Guetta',
        photo_url: '',
        post_url: 'https://www.linkedin.com/',
        related_profiles: ['2', '1'],
        language: 'en',
        created_at: '2019-08-08T11:27:03.000Z',
        state: 3,
        is_replied: 0,
        sentiment: 0,
        status: {
            created_at: '2022-03-16T11:24:00.000Z',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '138m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            media: [
                {
                    id: null,
                    id_str: '',
                    indices: null,
                    url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    expanded_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                    type: 'photo',
                    sizes: {
                        large: {
                            w: 452,
                            h: 418
                        }
                    }
                }
            ],
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'la',
                author_id: '105078848611979',
                social_type: socialMediaConfig.linkedin.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '912105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    social_type: socialMediaConfig.linkedin.id
                }
            }
        }
    },

    //Articles

    {
        description: 'Head of Marketing at Affogata',
        social_type: socialMediaConfig.article.id,
        name: 'Medium.com',
        photo_url: '',
        related_profiles: ['2', '1'],
        language: 'en',
        created_at: '2019-08-08T11:27:03.000Z',
        url: 'https://javascript.plainenglish.io/i-met-a-rich-programmer-he-gave-me-3-life-changing-pieces-of-advice-a3754d73a50c',
        state: 3,
        is_replied: 0,
        sentiment: 0,
        status: {
            created_at: '2022-03-15T13:24:00.000Z',
            full_text: `In your early days as a programmer, you will have a consistent feeling in your mind that, “The grass is always greener on another side of the fence”.
                You will notice that your friend is getting paid more than you for the same job. One of your friend's social media is gaining tons of followers.
                One of your friends is making living out of their stock investment. The life of your other friend is cooler as he travels abroad every month.
                A friend’s startup is on the verge of creating tons of wealth for them.
                You will see them all and think why the heck is their grass greener than yours.
                Until you reach a specific point in your career, you will keep comparing and that’s what 97% of newbie programmers do, they compare their wealth with their friends and start having a sense of self-doubt.
                But as a professional programmer, you must stop comparing and start working on your progress.
                Due to project-related work, I got a chance to interact with one of the experienced programmers whom I have idolized for the longest time.
                I simply asked him after discussing the project, “Is there any advice that you would give me for my programming journey?”
                `,
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '138m_4432mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQ',
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            media: [
                {
                    id: null,
                    id_str: '',
                    indices: null,
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    url: 'https://miro.medium.com/max/1400/0*5HWA6yLX2ljJjNq5',
                    media_url: 'https://miro.medium.com/max/1400/0*5HWA6yLX2ljJjNq5',
                    expanded_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                    type: 'photo',
                    sizes: {
                        large: {
                            w: 452,
                            h: 418
                        }
                    }
                }
            ]
        }
    },

    //Reviews & Forums

    {
        identity: {
            name: 'Julius Caesar',
            country: 'us'
        },
        stream_id: 418,
        assigned_to: null,
        state: 1,
        is_replied: 0,
        status_type: 23,
        sentiment: -1,
        language: 'en',
        author_followers_count: -1,
        social_type: socialMediaConfig.webreview.id,
        related_profiles: ['2', '1'],
        actions: {
            liked_by: [],
            replied_by: [],
            reviewed_by: [],
            sent_by: []
        },
        label_ids: [],
        status: {
            status_id: '61bee18a9f60695a25f97baf',
            created_at: '2021-12-19T07:38:50.000Z',
            full_text:
                "Terrible platform for starting e-commerce business, this platform is for those who likes to play with design tools but there is no power behind it, wix apps weight a lot for websites and adaptation along with customer conversion is not good. I highly recommend choosing another alternative platform, this one is really bad, and it's not safe either, we had a case with Wix when scammers attacked our website and we had dozens of fake transactions which we had to fulfill, there was no warning or fraud prevention, nothing just heaven for scammers.  Wix Payments is also trash, they are a 3rd party provider whose bank does not care about sellers, they suspended our payment account due the single chargeback, which was actually marked as refunded on our end, but didn`t go through their system that is not working well with Wix dashboard, that was a mismanagement of their fancy Wix App which we used to issue the refund. but they didn`t care and just locked our payment account entirely. Lastly, when we were moving out the Wix to another platform, we were trying to get refunded on the pro-rata basis for the pre-paid Premium subscription that we have till 2023,, we filed for the refund but we were refused as well, their home office is in Tel Aviv, assumingly the billing department is there too, that`s very bad treatment not in American fassion and not according to the forms and laws of doing buisness in the United States.  Terrible terrible company to work with, avoid Wix.",
            title: 'Terrible platform for starting…',
            status_type: 23,
            sentiment: 2,
            language: 'en',
            verified: false,
            rating: 3,
            user_mentions: [],
            is_spam: false,
            actions: {
                assignments: []
            },
            urls: [],
            media: [],
            url: 'https://www.trustpilot.com/reviews/61bee18a9f60695a25f97baf',
            tp: {
                source: 'Organic',
                review_verification_level: 'not-verified'
            },
            to: 'wix.com'
        }
    },

    //Tiktok

    {
        identity: {
            name: 'Julius Caesar',
            country: 'us'
        },
        stream_id: 418,
        assigned_to: null,
        state: 1,
        is_replied: 0,
        status_type: 23,
        post_url: 'https://www.tiktok.com/en/',
        sentiment: -1,
        language: 'en',
        author_followers_count: -1,
        social_type: socialMediaConfig.tiktok.id,
        related_profiles: ['2', '1'],
        actions: {
            liked_by: [],
            replied_by: [],
            reviewed_by: [],
            sent_by: []
        },
        label_ids: [],
        status: {
            status_id: '6123bee18a9f60695a25f97baf',
            created_at: '2021-12-19T07:38:50.000Z',
            full_text: `Honorable mention: "You look really tired." Spoiler alert, they already know that. #smallbusinessownerscheck #ecommercebusiness #wixecommerce.`,
            title: 'Terrible platform for starting…',
            status_type: 23,
            sentiment: 2,
            language: 'en',
            verified: false,
            rating: 3,
            user_mentions: [],
            is_spam: false,
            actions: {
                assignments: []
            },
            urls: [],
            media: [
                {
                    id: null,
                    id_str: '',
                    indices: null,
                    url: 'https://pbs.twimg.com/media/FF62lqHXMAU7tr9?format=jpg&name=small',
                    media_url: 'https://pbs.twimg.com/media/FF62lqHXMAU7tr9?format=jpg&name=small',
                    expanded_url: 'https://pbs.twimg.com/media/FF62lqHXMAU7tr9?format=jpg&name=small',
                    type: 'photo',
                    sizes: {
                        large: {
                            w: 452,
                            h: 418
                        }
                    }
                }
            ],
            url: 'https://www.trustpilot.com/reviews/61bee18a9f60695a25f97baf',
            tp: {
                source: 'Organic',
                review_verification_level: 'not-verified'
            },
            to: 'wix.com'
        }
    },

    //Wix Answers

    {
        identity: {
            name: 'Julius Caesar',
            country: 'us'
        },
        stream_id: 418,
        assigned_to: null,
        wix_status: 'Open',
        state: 1,
        is_replied: 0,
        status_type: 23,
        sentiment: -1,
        language: 'en',
        author_followers_count: -1,
        social_type: socialMediaConfig.wixan.id,
        related_profiles: ['2', '1'],
        actions: {
            liked_by: [],
            replied_by: [],
            reviewed_by: [],
            sent_by: []
        },
        label_ids: [],
        status: {
            status_id: '6123323bee18a9f60695a25f97baf',
            created_at: '2021-12-19T07:38:50.000Z',
            full_text: `Honorable mention: "You look really tired." Spoiler alert, they already know that. #smallbusinessownerscheck #ecommercebusiness #wixecommerce.`,
            title: 'Terrible platform for starting…',
            status_type: 23,
            sentiment: 2,
            language: 'en',
            verified: false,
            rating: 3,
            user_mentions: [],
            is_spam: false,
            actions: {
                assignments: []
            },
            urls: [],
            url: 'https://www.trustpilot.com/reviews/61bee18a9f60695a25f97baf',
            tp: {
                source: 'Organic',
                review_verification_level: 'not-verified'
            },
            to: 'wix.com'
        }
    },

    //Etoro

    {
        identity: {
            name: 'Caesar Salad',
            country: 'us'
        },
        created_at: '2021-12-19T07:38:50.000Z',
        description: 'Cesar Salad 12',
        stream_id: 418,
        assigned_to: null,
        wix_status: 'Open',
        state: 1,
        is_replied: 0,
        status_type: 23,
        sentiment: 1,
        language: 'it',
        author_followers_count: -1,
        social_type: socialMediaConfig.etoro.id,
        related_profiles: ['2', '1'],
        actions: {
            liked_by: [],
            replied_by: [],
            reviewed_by: [],
            sent_by: []
        },
        label_ids: [],
        status: {
            status_id: '612332343bee18a9f60695a25f97baf',
            created_at: '2021-12-19T07:38:50.000Z',
            full_text: `La Caesar salad è una celebre insalata creata dallo chef italiano Cesare Cardini, emigrato negli Stati Uniti dopo la prima guerra mondiale e vissuto a San Diego; nel 1924 Cesare apre e gestisce un ristorante a Tijuana, in Messico, dove crea questa insalata che diverrà molto famosa negli Stati Uniti e in seguito anche in Europa.`,
            title: 'Terrible platform for starting…',
            status_type: 23,
            sentiment: 2,
            language: 'it',
            verified: false,
            rating: 3,
            user_mentions: [],
            is_spam: false,
            actions: {
                assignments: []
            },
            in_reply_to_screen_name: 'Queen',
            urls: [],
            url: 'https://www.trustpilot.com/reviews/61bee18a9f60695a25f97baf',
            tp: {
                source: 'Organic',
                review_verification_level: 'not-verified'
            },
            to: 'wix.com',
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399000,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },

    {
        identity: {
            name: 'OzzyOsbourne',
            country: 'us'
        },
        photo_url: '',
        description: 'Ozzy Osbourne',
        created_at: '2022-01-01T11:27:03.000Z',
        post_url: 'https://www.instagram.com/',
        related_profiles: ['2'],
        author_id: 2,
        state: 1,
        is_replied: 1,
        sentiment: -1,
        language: 'la',
        social_type: socialMediaConfig.etoro.id,
        status: {
            created_at: '2022-03-19T12:24:00.000Z',
            subreddit_name: 'OzzyRedditOsbourne',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            status_id: '2m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQdef',
            favorite_count: 0,
            reply_count: 89,
            media: [
                {
                    title: 'Default post title', //@TODO - added only for testing
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.', //@TODO - added only for testing
                    id: 1460640335919399001,
                    id_str: '1460640335919398915',
                    indices: [268, 291],
                    media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    media_url_https: 'https://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                    url: 'https://t.co/Om4oMhMyms',
                    display_url: 'pic.twitter.com/Om4oMhMyms',
                    expanded_url: 'https://twitter.com/MarcelAndRogie/status/1460640341124476930/photo/1',
                    type: 'animated_gif',
                    sizes: {
                        large: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        thumb: {
                            w: 150,
                            h: 150,
                            resize: 'crop'
                        },
                        small: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        },
                        medium: {
                            w: 500,
                            h: 258,
                            resize: 'fit'
                        }
                    },
                    video_info: {
                        aspect_ratio: [250, 129],
                        variants: [
                            {
                                bitrate: 0,
                                content_type: 'video/mp4',
                                url: 'https://video.twimg.com/tweet_video/FEU8pY8VQAMJjpv.mp4'
                            }
                        ]
                    }
                }
            ]
        }
    },

    {
        identity: {
            name: 'DavidGuetta',
            country: 'us'
        },
        photo_url: '',
        language: 'en',
        description: 'David Guetta',
        created_at: '2019-08-08T11:27:03.000Z',
        post_url: 'https://www.instagram.com/',
        related_profiles: ['2', '1'],
        state: 3,
        author_id: 3,
        is_replied: 0,
        social_type: socialMediaConfig.etoro.id,
        sentiment: 0,
        status: {
            created_at: '2022-03-25T12:24:00.000Z',
            subreddit_name: 'Guetta123',
            full_text:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            user_mentions: [
                {
                    screen_name: 'Mr. Anderson',
                    name: 'Neo',
                    id: '1707877242',
                    id_str: '1707877242',
                    indices: [0, 12]
                }
            ],
            status_id: '3m_44mXIO2catQb_W16ifzG3PSKAsBlcrIpegQ3FCM5zfc6OzSBz2zehTLuiaSKODcu73m5Fv5-Fa_MFaBSb913IQdef',
            favorite_count: 9,
            in_reply_to_screen_name: 'OzzyOsbourne',
            reply_count: 4,
            quoted_status: {
                stream_id: 5849,
                assigned_to: null,
                state: 1,
                is_replied: 0,
                status_type: 12,
                sentiment: -1,
                language: 'en',
                author_id: '105078848611979',
                social_type: socialMediaConfig.facebook.id,
                related_profiles: [],
                actions: {
                    liked_by: [],
                    replied_by: [],
                    reviewed_by: []
                },
                label_ids: [],
                status: {
                    status_id: '105078848611979_105090378610826',
                    created_at: '2021-09-30T10:30:59.000Z',
                    full_text: `Post I\nThis is the new and first post, treat it well.
                        Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well.Berlin 🐻📍Friedrichstraße/ Torstraße ❌Post I\nThis is the new and first post, treat it well. Berlin 🐻 📍Friedrichstraße/ Torstraße ❌
                        📸 #dantekitchenbar #dante #adana #italyanmutfak #cocktails
                        `,
                    in_reply_to_status_id: '',
                    in_reply_to_user_id: '',
                    in_reply_to_screen_name: '',
                    in_reply_to_media_id: '',
                    parent_created_at_timestamp: null,
                    status_type: 12,
                    sentiment: -1,
                    language: 'en',
                    favorite_count: 2,
                    reply_count: 4,
                    user_mentions: [],
                    is_spam: false,
                    actions: {
                        assignments: []
                    },
                    urls: [],
                    url: 'https://www.facebook.com/105078848611979/posts/105090378610826/',
                    media: [
                        {
                            id: null,
                            id_str: '',
                            indices: null,
                            url: 'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            display_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            media_url: 'http://pbs.twimg.com/tweet_video_thumb/FEU8pY8VQAMJjpv.jpg',
                            media_url_https:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            expanded_url:
                                'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-6/243796052_105089655277565_4188182867941289785_n.png?_nc_cat=105&ccb=1-5&_nc_sid=8024bb&_nc_ohc=EhUc1J_RDLMAX-iGd7z&_nc_ht=scontent-lga3-1.xx&edm=AKK4YLsEAAAA&oh=25a78a8aec0d50bd71a53adc5011b41f&oe=61A91FCB',
                            type: 'photo',
                            sizes: {
                                small: {
                                    w: 150,
                                    h: 150
                                },
                                thumb: {
                                    w: 90,
                                    h: 90
                                },
                                medium: {
                                    w: 300,
                                    h: 300
                                },
                                large: {
                                    w: 452,
                                    h: 418
                                }
                            }
                        }
                    ],
                    card: {}
                },
                quoted_identity: {
                    identity_id: '105078848611979',
                    author_followers_count: 12312,
                    name: 'Affogata',
                    username: 'Affogata 95',

                    photo_url:
                        'https://scontent-lga3-1.xx.fbcdn.net/v/t39.30808-1/cp0/c2.0.50.50a/p50x50/243645646_105080128611851_2244237662891066539_n.png?_nc_cat=107&ccb=1-5&_nc_sid=dbb9e7&_nc_ohc=Ckr7yffDEn8AX9-oNJu&_nc_ht=scontent-lga3-1.xx&edm=AGz5Y0wEAAAA&oh=9bf156a711ec58f3ea9308884360b23f&oe=61A88F27',
                    fb_user_type: 2,
                    social_type: socialMediaConfig.facebook.id
                }
            }
        }
    }
];
